<div class="qb-w-100 qb-h-100">
    <div
      class="qb-offer-section-header qb-offer-section-header2 qb-top-container qb-padding-30"
    >
      <div>
        <app-breadcrumb></app-breadcrumb>
      </div>
      <div class="qb-offer-all-heading">
        <button
          class="primary-button qb-create-new-offer-button"
          (click)="createOffer()"
          data-button-name="Create New Gift Code"
          [disabled]="'ROLE_READ_ONLY' | checkIfViewOnly:'disable'" 
          [matTooltip]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable') ? ('ROLE_READ_ONLY' | checkIfViewOnly:'tooltip') : ('')"
          [class.disabled-button]="('ROLE_READ_ONLY' | checkIfViewOnly:'disable')"        
        >
          <mat-icon class="qb-add-icon">add</mat-icon>
          {{ "OFFER_PAGE.CREATE_GIFT_CODE" | i18nTranslate }}
        </button>
      </div>
    </div>
    <div
      class="qb-main"
      *ngIf="validWidgets"
      id="viewconfigDiv"
      data-widget-name="OFFER LISTING"
      (scroll)="onScroll($event)"
    >
      <div
        class="qb-offer-section-header qb-offer-section-header2 qb-offer-list-heading-wrapper"
      >
        <div class="module-heading">GiftCode List</div>
        <div class="qb-offer-list-main-div">
          <div class="qb-form-div-search qb-form-search">
            <input
              #search
              class="qb-form-input"
              [(ngModel)]="filter.label"
              type="text"
              placeholder="Search by name"
              (input)="onKeySearch($event)"
            />
            <span
              class="material-icons-outlined icons-primary"
              *ngIf="filter.label.length == 0"
            >
              search
            </span>
            <span
              class="material-icons-outlined icons-primary cursor-pointer qb-close-icon"
              *ngIf="filter.label.length > 0"
              (click)="filter.label = ''; onKeySearch($event)"
            >
              close
            </span>
          </div>
          <div>
            <!-- <div
              class="filterButton button-hover-effect"
              (click)="openFilterDialog()"
              data-button-name="Filter"
            >
              <div style="display: flex">
                <span
                  class="material-icons-outlined icons-primary"
                  style="cursor: pointer"
                  [matTooltipShowDelay]="200"
                  [matTooltip]="'COMMON_PAGE.FILTERS' | i18nTranslate"
                >
                  filter_alt
                </span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
      <div
        *ngIf="validWidgets | widgetConfig : 28"
        class="qb-widget-div qb-padding-header-padding"
      >
        <div>
          <div
            class="qb-offer-section-header qb-table-header"
            [style.padding-right.px]="rightMargin"
            id="tableHeads"
          >
            <div class="qb-column-heading-div-name">
              <span class="qb-offer-section-head-name">{{
                "OFFER_PAGE.GIFT_CODE_NAME" | i18nTranslate
              }}</span>
            </div>
            <!-- <div class="qb-column-heading-div qb-column-heading-channel">
              <span class="qb-offer-section-head qb-center">{{
                "OFFER_PAGE.CHANNEL" | i18nTranslate
              }}</span>
            </div> -->
            <div
              class="qb-column-heading-div qb-column-heading-segments-targeted"
            >
              <span class="qb-offer-section-head qb-word-wrapper">{{
                "OFFER_PAGE.TARGETED_AUDIENCE" | i18nTranslate
              }}</span>
            </div>
            <div class="qb-column-heading-status">
              <span class="qb-offer-section-head qb-center"
                >{{ "OFFER_PAGE.STATUS" | i18nTranslate }}
              </span>
            </div>
            <div class="qb-column-heading-status">
              <span class="qb-offer-section-head qb-center">Created At </span>
            </div>
          </div>
        </div>
        <div class="qb-table-content" id="side-menu-offer-parent">
          <div
            class="qb-offer-list-div"
            *ngFor="let offer of offerList; let i = index"
            id="side-menu-offer"
          >
            <div
              class="qb-offer-section-body"
              *ngIf="!loading && !mobileView"
              id="a"
            >
              <div
                class="qb-offer-value qb-list-head-offer-name"
              >
                <div>
                  <span
                    class="qb-offer-section-offer-name"
                    (click)="
                      previewOrEditOffer(
                        offer['id']
                      )
                    "
                    [matTooltip]="offer['name']"
                    matTooltipClass="ex-tooltip-red1"
                    data-button-name="Offer Name"
                    [attr.data-item-name]="
                      '(' + offer['id'] + ')' + offer['name']
                    "
                    >{{ offer['name'] | limitTo : 30 }}</span
                  >
                  <div
                    style="font-size: 10px"
                    class="mini-list-item"
                    [matTooltip]="
                    'Created by ' +  (offer?.createdBy?.userName 
                    ? offer.createdBy.userName + '\n' + (offer?.createdBy?.userEmail || '') 
                    : offer?.createdBy?.storeName || '')
                  "
                  matTooltipClass="custom-tooltip"
                  >
                    <span class="material-symbols-outlined">person_edit</span>
                    {{
                      offer?.createdBy?.storeName
                        ? offer["createdBy"]["storeName"]
                        : ("-" | titlecase)
                    }}
                  </div>
                </div>
              </div>
              <!-- <div
                class="qb-list-head-offer qb-offer-channel"
              >
                <span
                  class="qb-offer-section-value"
                >
                  <div>
                    <span
                      [matTooltip]="getTooltipOffer('SMS')"
                      style="margin-right: 5px"
                      *ngIf="checkChannel('SMS', offer['channel'])"
                    >
                      <img
                        src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/whatsapp/sms.svg"
                        width="15px"
                        height="15px"
                      />
                    </span>
                    <span
                      style="margin-right: 5px"
                      [matTooltip]="getTooltipOffer('Email')"
                      *ngIf="checkChannel('EMAIL', offer['channel'])"
                    >
                      <img
                        src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/whatsapp/email.svg"
                        width="15px"
                        height="15px"
                      />
                    </span>
                    <span
                      [matTooltip]="getTooltipOffer('WhatsApp')"
                      style="margin-right: 5px"
                      *ngIf="checkChannel('WHATSAPP', offer['channel'])"
                    >
                      <img
                        src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/whatsapp/whatsapp.svg"
                        width="15px"
                        height="15px"
                      />
                    </span>
  
                    <span
                      [matTooltip]="getTooltipOffer('Mobile')"
                      style="margin-right: 5px"
                      *ngIf="checkChannel('appOnly', offer['channel'])"
                    >
                      <img
                        src="https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/icons/Mobile/phone_iphone_FILL0_wght400_GRAD0_opsz24.svg"
                        width="15px"
                        height="15px"
                      />
                    </span>
  
                    <span
                      [matTooltip]="getTooltipOffer('POS')"
                      style="margin-right: 5px"
                      *ngIf="checkChannel('POS', offer['channel'])"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="15px"
                        viewBox="0 -960 960 960"
                        width="15px"
                        fill="#5f6368"
                      >
                        <path
                          d="M240-120v-80h200v-120H160q-33 0-56.5-23.5T80-400v-360q0-33 23.5-56.5T160-840h640q33 0 56.5 23.5T880-760v360q0 33-23.5 56.5T800-320H520v120h200v80H240Zm-80-280h640v-360H160v360Zm0 0v-360 360Z"
                        />
                      </svg>
                    </span>
                    <span
                      [matTooltip]="getTooltipOffer('Push Notification')"
                      style="margin-right: 5px"
                      *ngIf="
                        checkChannel('pushNotification', offer['channel'])
                      "
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="20px"
                        viewBox="0 -960 960 960"
                        width="20px"
                        fill="#5f6368"
                      >
                        <path
                          d="M80-560q0-100 44.5-183.5T244-882l47 64q-60 44-95.5 111T160-560H80Zm720 0q0-80-35.5-147T669-818l47-64q75 55 119.5 138.5T880-560h-80ZM160-200v-80h80v-280q0-83 50-147.5T420-792v-28q0-25 17.5-42.5T480-880q25 0 42.5 17.5T540-820v28q80 20 130 84.5T720-560v280h80v80H160Zm320-300Zm0 420q-33 0-56.5-23.5T400-160h160q0 33-23.5 56.5T480-80ZM320-280h320v-280q0-66-47-113t-113-47q-66 0-113 47t-47 113v280Z"
                        />
                      </svg>
                    </span>
  
                    <span
                      *ngIf="
                        offer['channel'] === null && offer['channel'] === null
                      "
                    >
                      -
                    </span>
                  </div>
                </span>
              </div> -->
              <div
                class="qb-list-head-offer qb-segment-div"
              >
                <span
                  class="qb-segment-value-div overflow-ellipsis-2"
                  *ngIf="offer['segmentNames'] != null"
                >
                  <span
                    class="qb-offer-section-value qb-no-padding"
                    *ngFor="
                      let segment of offer['segmentNames'] | keyvalue;
                      last as islast
                    "
                    #segmentnamefield
                    >{{ segment.value }} <span *ngIf="!islast">,</span></span
                  >
                </span>
                <mat-icon
                  class="qb-double-arrow-icon"
                  [matMenuTriggerFor]="menusegment"
                  *ngIf="offer['segmentNames'] != null"
                  >double_arrow
                </mat-icon>
                <mat-menu #menusegment="matMenu">
                  <div class="qb-segment-value">
                    <span
                      *ngFor="
                        let segment of offer['segmentNames'] | keyvalue;
                        last as islastseg
                      "
                    >
                      {{ segment.value }}<span *ngIf="!islastseg">,</span></span
                    >
                  </div>
                </mat-menu>
                <span
                  *ngIf="
                    offer['segmentNames'] == null && offer['status'] == 'Draft'
                  "
                  class="qb-offer-section-value qb-no-padding"
                  >-</span
                >
                <span
                  *ngIf="
                    (offer['segmented'] == false &&
                      offer['allCustomer']) ||
                    (offer['segmented'] == false &&
                      !offer['allCustomer'] &&
                      !offer['allLead'] && offer['customerIds'] == null)
                  "
                  class="offerSectionValue qb-no-padding"
                  >{{ "OFFER_PAGE.ALL_CUSTOMERS" | i18nTranslate }}</span
                >
                <span
                  *ngIf="offer['allLead']"
                  class="offerSectionValue qb-no-padding"
                  >{{ "CAMPAIGN_PAGE.ALL_LEADS" | i18nTranslate }}</span
                >
                <span
                *ngIf="offer['customerIds']!=null "
                class="offerSectionValue qb-no-padding"
                >{{ "OFFER_PAGE.INDIVIDUAL_CUSTOMER" | i18nTranslate }}</span
              >
              </div>
              <div
                class="qb-list-head-offer qb-list-head-offer-status"
              >
                <div
                  class="qb-flag-icon-div"
                  [ngClass]="{
                    'qb-active':
                      offer['status'] === 'SENT' ,
                    'qb-scheduled': offer['status'] === 'SCHEDULED'
                  }"
                >
                  <span
                    *ngIf="offer['status'] == 'SENT'"
                    class="qb-mr-r-25"
                    >{{ "OFFER_PAGE.SENT" | i18nTranslate }}</span
                  >
                  <span
                    *ngIf="offer['status'] == 'SCHEDULED'"
                    class="qb-scheduled qb-mr-r-25"
                    >{{ "OFFER_PAGE.SCHEDULED" | i18nTranslate }}</span
                  >
                </div>
              </div>
              <div class="qb-list-head-offer qb-list-last-updated">
                <span *ngIf="offer['status'] == 'SENT'" class="qb-column">
                  <span class="qb-status-sub-text">{{
                    "OFFER_PAGE.CREATED_AT" | i18nTranslate
                  }}</span>
                  <span
                    class="qb-sent-on-value"
                  >
                    {{
                      offer["createdAtTime"] | date : getDateFormat("MMM dd yyyy")
                    }}
                    | {{ offer["createdAtTime"] | customTime }}
                  </span>
                </span>
                <span *ngIf="offer['status'] == 'SCHEDULED'" class="qb-column">
                  <span class="qb-status-sub-text">{{
                    "OFFER_PAGE.CREATED_AT" | i18nTranslate
                  }}</span>
                  <span
                    class="qb-sent-on-value"
                  >
                    {{
                      offer["createdAtTime"] | date : getDateFormat("MMM dd yyyy")
                    }}
                    | {{ offer["createdAtTime"] | customTime }}
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div *ngIf="loading && !mobileView" class="qb-spinner">
            <mat-spinner diameter="22"></mat-spinner>
          </div>
          <div *ngIf="offerList.length == 0 && !loading">
            <div class="qb-no-data">
              <div class="qb-empty-customers-div">
                {{ "OFFER_PAGE.NO_DATA_AVAILABLE" | i18nTranslate }}
              </div>
            </div>
          </div>
        </div>
        <div class="qb-paginate-div">
          <mat-paginator
            #paginator
            [pageIndex]="0"
            [length]="totalOfferCount"
            [pageSize]="size"
            [pageSizeOptions]="[5, 10, 25, 100]"
            (page)="getNextData($event)"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
  <div id="overlay"></div>
  